export enum MultiUnitGridABTestVariants {
  MULTI_UNIT = "multi_unit",
  NORMAL_CARD = "normal_card",
}

export const VARIANT_KEY = "multi_unit_ab_test"
export const VARIANT_OPTIONS: string[] = [
  MultiUnitGridABTestVariants.MULTI_UNIT,
  MultiUnitGridABTestVariants.NORMAL_CARD,
]

export const VARIANT_WEIGHTS: number[] = [50, 50] as const
export const DEFAULT_VARIANT = MultiUnitGridABTestVariants.MULTI_UNIT

/**
 * TODO: remove ab testin logic from all places as testing is done.
 * Currently returning NORMAL_CARD directly.
 * as NORMAL_CARD variant is selected after testing.
 */

export const getMultiUnitGridABTestingVariant = () => {
  return MultiUnitGridABTestVariants.NORMAL_CARD
  // return determineABTestVariation(
  //   VARIANT_KEY,
  //   VARIANT_OPTIONS,
  //   VARIANT_WEIGHTS,
  //   DEFAULT_VARIANT,
  // ) as MultiUnitGridABTestVariants
}
